/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const SkillType = {
    Other: 'Other',
    Hard: 'Hard',
    Soft: 'Soft',
    Language: 'Language'
};
export function instanceOfSkillType(value) {
    for (const key in SkillType) {
        if (Object.prototype.hasOwnProperty.call(SkillType, key)) {
            if (SkillType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function SkillTypeFromJSON(json) {
    return SkillTypeFromJSONTyped(json, false);
}
export function SkillTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function SkillTypeToJSON(value) {
    return value;
}
export function SkillTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
